import styled from 'styled-components';

interface ToggleSwitchProps {
  /* 토글 스위치가 활성화 상태인지 체크함 true = 활성화 , false = 비활성화 */
  isChecked: boolean;
  /* 토글 스위치 변경 이벤트 */
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  /* 토글 스위치 색상 (기본값: #2196f3) */
  sliderColor?: string;
  /* 토글 스위치 너비 (기본값: 53px) */
  width?: string;
  /* 토글 스위치 높이 (기본값: 30px) */
  height?: string;
  /* 써클 너비 (기본값: 23px) */
  circleWidth?: string;
  /* 써클 높이 (기본값: 23px) */
  circleHeight?: string;
}
interface SwitchProps {
  sliderColor?: string;
  width: string;
  height: string;
  circleWidth: string;
  circleHeight: string;
}

const Switch = styled.label<SwitchProps>`
  position: relative;
  display: inline-block;
  width: ${(props) => props.width};
  height: ${(props) => props.height};

  & input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  & .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: ${(props) => props.height};
  }

  & .slider:before {
    position: absolute;
    content: '';
    height: ${(props) => props.circleHeight};
    width: ${(props) => props.circleWidth};
    left: 2px;
    bottom: ${(props) => {
      const heightNum = parseFloat(props.height);
      const circleHeightNum = parseFloat(props.circleHeight);
      return `${(heightNum - circleHeightNum) / 2}px`;
    }};
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: ${(props) => props.sliderColor || '#2196f3'};
  }

  input:checked + .slider:before {
    transform: translateX(calc(${(props) => props.width} - ${(props) => props.circleWidth} - 4px));
  }
`;

function ToggleSwitch({
  isChecked,
  onChange,
  sliderColor,
  width = '53px',
  height = '30px',
  circleWidth = '23px',
  circleHeight = '23px',
}: ToggleSwitchProps) {
  return (
    <Switch sliderColor={sliderColor} width={width} height={height} circleWidth={circleWidth} circleHeight={circleHeight}>
      <input type="checkbox" checked={isChecked} onChange={onChange} />
      <span className="slider"></span>
    </Switch>
  );
}
export default ToggleSwitch;
